import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { governmentAllocationEntriesKind } from '@/common/constants/governmentAllocationEntriesKind.constant'
import { cn } from '@/common/utils/cn'
import { formatCurrency } from '@/common/utils/formatters'
import { companyGovernmentAllocationEntryStatusStrategy } from '@/features/privateCompanies/pages/CompanyGovernmentAllocations/Show/constants/governmentAllocationEntryStatus.constant'
import { CompanyGovernmentAllocationEntriesResponse } from '@/features/privateCompanies/types/companyGovernmentAllocationEntry.type'
import { format } from 'date-fns'
import { ArrowBigRight, User2Icon } from 'lucide-react'
import { Link } from 'react-router-dom'

export class CompanyGovernmentAllocationDocumentsTransformer {
  static tableTransformer(companyId: string) {
    return (companyGovernmentAllocationEntries: CompanyGovernmentAllocationEntriesResponse['data']['data']) => {
      return companyGovernmentAllocationEntries.map((companyGovernmentAllocationEntry) => ({
        office_number: companyGovernmentAllocationEntry.office_number,
        total_value: (
          <p
            className={cn(
              'text-end',
              Number(companyGovernmentAllocationEntry.total_value) >= 0 ? 'text-valid' : 'text-danger-soft',
            )}
          >
            {formatCurrency(Number(companyGovernmentAllocationEntry.total_value))}
          </p>
        ),
        kind: governmentAllocationEntriesKind[
          companyGovernmentAllocationEntry.kind as keyof typeof governmentAllocationEntriesKind
        ],
        status:
          companyGovernmentAllocationEntryStatusStrategy[
            companyGovernmentAllocationEntry.status as keyof typeof companyGovernmentAllocationEntryStatusStrategy
          ],
        created_at: format(new Date(companyGovernmentAllocationEntry.created_at), 'dd/MM/yyyy'),
        requester: companyGovernmentAllocationEntry?.creator ? (
          <ImageWithDisplayName
            placeholderIcon={User2Icon}
            imageUrl={companyGovernmentAllocationEntry?.creator?.profile_picture?.url}
            displayName={companyGovernmentAllocationEntry?.creator?.full_name}
            imageClassName="size-8"
            iconClassName="size-6"
          />
        ) : undefined,
        responsible: companyGovernmentAllocationEntry?.reviewer ? (
          <ImageWithDisplayName
            placeholderIcon={User2Icon}
            imageUrl={companyGovernmentAllocationEntry?.reviewer?.profile_picture?.url}
            displayName={companyGovernmentAllocationEntry?.reviewer?.full_name}
            imageClassName="size-8"
            iconClassName="size-6"
          />
        ) : undefined,
        action: (
          <Link to={`/companies/${companyId}/government-allocations/${companyGovernmentAllocationEntry.id}/edit`}>
            <ArrowBigRight />
          </Link>
        ),
      }))
    }
  }
}
